export default "__VITE_ASSET__CjPtiQOR__"